import React from 'react'
import Hero from './Hero'
import Features from './Features'
import Footer from '../footer/Footer'

const Home = () => {
  return (
    <div className="">
      {/* Hero Section */}
      <Hero />
      
      {/* Features Section */}
      <div className="bg-gray-50">
        <Features />
      </div>
      
      {/* Footer Section */}
      <Footer />
    </div>
  )
}

export default Home
